import React from "react";
import {Checkbox, message} from "antd";
import {connect} from "react-redux";
import {CheckboxChangeEvent} from "antd/lib/checkbox";
import "../DynamicForm.scss";
import {CheckboxElementProps} from "@data-force/app";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";
import MarkdownMedia from "../../Markdown/MarkdownMedia";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = CheckboxElementProps & DispatchProps;

class CheckboxElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.checkboxChangeHandler = this.checkboxChangeHandler.bind(this);
    }

    checkboxChangeHandler(event: CheckboxChangeEvent): void {
        const {
            fieldName, index, refElements, onSave,
        }: CheckboxElementProps = this.props;
        this.props.onChange({
            fieldName, value: event.target.checked, index, refElements,
        });

        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: event.target.value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    render() {
        const {
            label, value, className = "", readOnly, signType,
        }: CheckboxElementProps = this.props;

        return (
            <Checkbox
                className={className}
                checked={value as boolean}
                onChange={this.checkboxChangeHandler}
                disabled={readOnly}
            >
                <MarkdownMedia signType={signType}>
                    {label}
                </MarkdownMedia>
            </Checkbox>
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(CheckboxElement);
